import { styled } from "@mui/material/styles";

export const TicketIconContainer = styled('div')(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const CustomTicketIconText = styled("div")(({ theme }) => ({
  position: "absolute",
  textAlign: "center",
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.xs,
  fontWeight: theme.fontWeights.bold,
  lineHeight: "100%"
}));
